import React, { FC, useState } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper.js";
import useSelfRemovalLink from "hooks/useSelfRemovalLink.tsx";
import FilesActionGroup from "components/Reusable/FilesActionGroup/FilesActionGroup.js";
import { useInView } from "react-intersection-observer";
import { useMail } from "contexts/mailContext/mailContext.js";
import { useActionList } from "hooks/useActionList.js";
import { useContent } from "contexts/contentContext/contentContext.js";

type FolderItemProps = {
  folderId: string;
};

const FolderItem: FC<FolderItemProps> = ({ folderId }) => {
  const { getMailSecurity, getFoldersData, setCurrentFolder } = useMail();
  const { getTextByKey } = useContent();
  const [ref, inView] = useInView();

  const folderData = getFoldersData()[folderId];
  const { size, type } = bytesToDisplayHelper(folderData.nestedFilesSize);
  const [hover, setHover] = useState(false);

  const actionList = useActionList({
    defaultActionList: ["Download", "Share", "Collection"],
    security: getMailSecurity(),
  });

  const handleSelectFolder = () => {
    setCurrentFolder(folderId);
  };

  const isSelfRemove = useSelfRemovalLink();

  const conditionToShowActions = inView && !isSelfRemove && hover;

  return (
    <div
      className="list-elem folder-item row"
      ref={ref}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={handleSelectFolder}
    >
      <div className="col-6 list-elem-name">
        <div className="select-icon hidden" />
        <div className="image-box">
          <Icon name="folders" gray />
        </div>
        {folderData.folderName}
      </div>
      <div className="col-2">{getTextByKey("folder")}</div>
      <div className={`col-${isSelfRemove ? "4 text-end" : "2"}`}>
        {size} {type}
      </div>
      <div className="col-2 text-end">
        {conditionToShowActions && (
          <FilesActionGroup actionList={actionList} folderId={folderId} />
        )}
      </div>
    </div>
  );
};

export default FolderItem;
